<template>
    <nav
        aria-label="Progress"
        class="mb-4 select-none"
    >
        <ol
            class="divide-y divide-gray-300 rounded-md border border-gray-300 md:flex md:divide-y-0"
        >
            <li
                v-for="(step, stepIdx) in steps"
                :key="step.name"
                class="relative md:flex md:flex-1"
            >
                <router-link
                    v-if="step.status === 'complete'"
                    :to="step.path"
                    class="group flex w-full items-center"
                >
                    <span class="flex items-center px-6 py-4 text-sm font-medium">
                        <span
                            class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-blue-600 group-hover:bg-blue-800"
                        >
                            <MdiCheck
                                class="h-6 w-6 text-white"
                                aria-hidden="true"
                            />
                        </span>
                        <span class="ml-4 text-sm font-medium text-gray-900">{{ step.title }}</span>
                    </span>
                </router-link>
                <div
                    v-else-if="step.status === 'current'"
                    class="flex items-center px-6 py-4 text-sm font-medium"
                    aria-current="step"
                >
                    <span
                        class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gray-200"
                    >
                        <span class="text-gray-600">{{ step.id }}</span>
                    </span>
                    <span class="ml-4 text-sm font-medium text-gray-900">
                        {{ step.title }}
                    </span>
                </div>
                <div
                    v-else
                    class="group flex items-center"
                >
                    <span class="flex items-center px-6 py-4 text-sm font-medium">
                        <span
                            class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border-2 border-gray-300"
                        >
                            <span class="text-gray-500">
                                {{ step.id }}
                            </span>
                        </span>
                        <span class="ml-4 text-sm font-medium text-gray-500">
                            {{ step.title }}
                        </span>
                    </span>
                </div>
                <template v-if="stepIdx !== steps.length - 1">
                    <!-- Arrow separator for lg screens and up -->
                    <div
                        class="absolute top-0 right-0 hidden h-full w-5 md:block"
                        aria-hidden="true"
                    >
                        <svg
                            class="h-full w-full text-gray-300"
                            viewBox="0 0 22 80"
                            fill="none"
                            preserveAspectRatio="none"
                        >
                            <path
                                d="M0 -2L20 40L0 82"
                                vector-effect="non-scaling-stroke"
                                stroke="currentcolor"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </div>
                </template>
            </li>
        </ol>
    </nav>
</template>
<script setup>
    import { MdiCheck } from 'materialdesignicons-vue3/icons/';

    const props = defineProps({
        steps: {
            type: Object,
            required: true,
        },
    });

    const steps = props.steps;
</script>
